// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZCclENJJHaC8JBrlChmA {\n\twidth: 400px;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/styles/FormPopover.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb","sourcesContent":[".form {\n\twidth: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": "ZCclENJJHaC8JBrlChmA"
};
export default ___CSS_LOADER_EXPORT___;
